'use client'

import { type ButtonHTMLAttributes, memo, useCallback } from 'react'
import clsx from 'clsx'

import { Promotion } from 'modules/products'
import { Modal, ModalTitle } from 'shared/ui/Modal'

import SpecialPromotionContent from './SpecialPromotionContent'

import styles from './SpecialPromotionModal.module.scss'

const SpecialPromotionCloseButton = ({
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button className={clsx(styles.closeButton, className)} {...props} />
)

const SpecialPromotionModal = memo(
  ({
    open,
    handleClose,
    promotion
  }: {
    open: boolean
    handleClose: () => void
    promotion: Promotion
  }) => {
    const handleClick = useCallback(() => {
      handleClose()
    }, [handleClose])

    return (
      <Modal id='special-promotion-modal' open={open} onClose={handleClose}>
        <ModalTitle>Szczegóły promocji</ModalTitle>
        <div className={styles.container}>
          <SpecialPromotionContent promotion={promotion} />

          <SpecialPromotionCloseButton onClick={handleClick}>
            Zamknij
          </SpecialPromotionCloseButton>
        </div>
      </Modal>
    )
  }
)

export default SpecialPromotionModal
